"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uiSchema = void 0;
var _constants = require("../../common/constants");
var _CustomLinkField = _interopRequireDefault(require("../../common/CustomLinkField"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const uiSchema = (linkText, linkUrl) => {
  return {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        type: "primary",
        block: true,
        size: "large"
      },
      submitText: _constants.formConstants.buttons.LOGIN
    },
    emailAddress: {
      "ui:options": {
        label: false,
        placeholder: _constants.formConstants.requiredFields.EMAIL
      },
      "ui:autocomplete": "nope"
    },
    password: {
      "ui:widget": "password",
      "ui:options": {
        label: false,
        placeholder: _constants.formConstants.requiredFields.PASSWORD
      },
      "ui:autocomplete": "nope"
    },
    passwordResetLink: {
      "ui:options": {
        label: false
      },
      "ui:widget": _CustomLinkField.default,
      "ui:widgetProps": {
        linkText: linkText,
        linkUrl: linkUrl
      }
    }
  };
};
exports.uiSchema = uiSchema;